const deployUrl = "https://rdgroup-backend-production.up.railway.app";
export const currentUrl = deployUrl;
